import { useMemo } from 'react';
import type { IconColor, IconSize } from '../../icons/types';
import type { IconBubbleSize, IconBubbleVariant } from './types';

const BUBBLE_TO_ICON_SIZE: Record<IconBubbleSize, IconSize> = {
  '3xl': '3xl',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xl: 'xl',
  xs: 'xs',
  xxl: 'xxl',
};

type UseIconBubbleParams = {
  color?: IconColor;
  size?: IconBubbleSize;
  variant?: IconBubbleVariant;
};

export default function useIconBubble({ color, size = 'md', variant = 'default' }: UseIconBubbleParams): {
  bubbleSize: IconBubbleSize;
  colorState: IconColor;
  iconSizeState: IconSize;
} {
  const colorState = useMemo(() => color ?? (variant === 'inverse' ? 'primary' : 'white'), [color, variant]);
  const iconSizeState = BUBBLE_TO_ICON_SIZE[size];

  return { bubbleSize: size, colorState, iconSizeState };
}
